import { Routes, Route } from 'react-router-dom'
import {
  Preview, ManageRows, ManageSettings, ManageThemes
} from '../components'
import {
  TemplateCatalog, ViewPluginEditor, Home, MessageCatalog, PageCatalog, PopupCatalog
} from '../views'

const BeeRoutes = () => {
  return (
    <>
      <Routes>
        <Route path={'/templates'} element={<TemplateCatalog />} />
        <Route path={'/emails'} element={<MessageCatalog />} />
        <Route path={'/pages'} element={<PageCatalog />} />
        <Route path={'/popups'} element={<PopupCatalog />} />
        <Route path={'/edit/:row/:env?'} element={<ViewPluginEditor />} />
        <Route path={'/preview/:env?'} element={<Preview />} />
        <Route path={'/join/:product/:sessionid?'} element={<ViewPluginEditor />} />
        <Route path={'/message/:product/:id/:mode?/:sessionId?'} element={<ViewPluginEditor />} />
        <Route path={'/template/:product/:template'} element={<ViewPluginEditor />} />
        <Route path={'/demo/:id/:env?'} element={<ViewPluginEditor />} />
        <Route path={'/manage-rows/:env?'} element={<ManageRows />} />
        <Route path={'/manage-settings/:env?'} element={<ManageSettings />} />
        <Route path={'/manage-themes/:theme?'} element={<ManageThemes />} />
        <Route path={'/'} element={<Home />} />
      </Routes>
    </>
  )
}
export default BeeRoutes
